import React from 'react';
import useReveal from '../hooks/useReveal';

// Wraps children with a scroll reveal animation
export function Reveal({ children, delay = 0, className = '' }) {
  const [ref, inView] = useReveal();
  return (
    <div ref={ref} className={`reveal ${inView ? 'in-view' : ''} ${className}`} style={{ animationDelay: `${delay}ms` }}>
      {children}
    </div>
  );
}

// Reusable page hero banner used across inner pages
export function PageHero({ eyebrow, title, subtitle, image }) {
  return (
    <section className="relative overflow-hidden">
      <div className="deep-section">
        <div className="container-x py-16 md:py-24 relative z-10">
          <div className="max-w-3xl">
            {eyebrow && <span className="inline-block text-teal-200 text-sm font-semibold tracking-widest uppercase mb-4">{eyebrow}</span>}
            <h1 className="text-white text-4xl md:text-5xl leading-[1.08] text-balance" style={{ fontWeight: 600 }}>{title}</h1>
            {subtitle && <p className="text-teal-100/85 text-lg mt-5 max-w-2xl leading-relaxed">{subtitle}</p>}
          </div>
        </div>
        {image && (
          <div className="absolute right-0 top-0 h-full w-1/2 hidden lg:block" style={{ opacity: 0.22 }}>
            <img src={image} alt="" className="h-full w-full object-cover" style={{ maskImage: 'linear-gradient(to right, transparent, black 60%)', WebkitMaskImage: 'linear-gradient(to right, transparent, black 60%)' }} />
          </div>
        )}
        <div className="absolute -bottom-24 -left-24 w-80 h-80 rounded-full blob" style={{ background: 'rgba(20,184,166,0.15)' }} />
      </div>
    </section>
  );
}

export function SectionTitle({ eyebrow, title, sub, center }) {
  return (
    <div className={`${center ? 'text-center mx-auto' : ''} max-w-2xl mb-12`}>
      {eyebrow && <span className="inline-block text-teal-600 text-sm font-semibold tracking-widest uppercase mb-3">{eyebrow}</span>}
      <h2 className="text-3xl md:text-4xl text-teal-900 leading-tight text-balance" style={{ fontWeight: 600 }}>{title}</h2>
      {sub && <p className="text-slate-600 mt-4 text-lg leading-relaxed">{sub}</p>}
    </div>
  );
}
